
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcabs() {



    const cardData =
    {
        keyword: 'Pune to Bhimashankar Cab',
        heading: 'Platinum24 Cabs: Pune to Bhimashankar Cab',
        headingDescription: 'Platinum24 Cabs offers trusted Pune to Bhimashankar Cab services for pilgrims and travelers heading to the sacred Bhimashankar Jyotirlinga Temple and the surrounding wildlife sanctuary. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey through scenic ghat routes. With professional drivers experienced in hill driving, punctual service, and transparent fares, we make your spiritual trip smooth and worry-free. Whether it’s a same-day darshan, a weekend getaway, or a family outing, Platinum24 Cabs guarantees reliability, affordability, and a memorable Pune to Bhimashankar travel experience.',

        top: 'Top Places to Visit in Bhimashankar with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "The Bhimashankar Temple is one of the 12 Jyotirlingas of Lord Shiva, located amidst the Sahyadri hills. Built in the Nagara style, it exudes ancient charm and spiritual energy. Devotees believe that darshan here washes away sins and grants liberation. The temple is especially crowded during Mahashivratri. Surrounded by lush forests, it combines faith with nature. Bhimashankar Temple is the spiritual heart of the region."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary is a protected reserve surrounding the Jyotirlinga Temple. It is home to the endangered Indian giant squirrel (Shekru), the state animal of Maharashtra. The sanctuary’s dense forests, waterfalls, and trekking trails attract both nature lovers and adventure seekers. Birdwatchers find rare species here. Monsoon makes it a paradise of mist and greenery. It is Bhimashankar’s haven of biodiversity and peace."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a hidden shrine located deep within the forest, associated with Lord Shiva. Pilgrims trek through scenic trails to reach this sacred spot. A natural spring flows here, believed to be the origin of the Bhima River. The calm atmosphere makes it ideal for meditation and devotion. Fewer crowds ensure a serene experience. Gupt Bhimashankar is the region’s hidden spiritual retreat."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a peaceful waterbody near the Bhimashankar Temple, surrounded by forests and hills. It is believed to be associated with Lord Hanuman. Pilgrims and trekkers stop here to relax amidst nature. The lake is also a favorite for birdwatchers spotting migratory species. Its calm waters reflect the greenery around, creating a serene view. Hanuman Lake is Bhimashankar’s natural picnic spot."
  },
  {
    "title": "Nagphani (Duke’s Nose)",
    "description": "Nagphani, also called Duke’s Nose, is a cliff near Bhimashankar offering breathtaking valley views. The peak resembles a snake’s hood, hence its name. It is a popular trekking and rock-climbing destination. Adventure enthusiasts love the challenging trails here. Monsoon mist makes the experience magical. Nagphani is Bhimashankar’s thrilling adventure landmark."
  },
  {
    "title": "Bombay Point",
    "description": "Bombay Point is a famous viewpoint offering panoramic views of the valleys and distant hills. It gets its name as it overlooks the route toward Mumbai. Visitors enjoy sunsets here, with the landscape bathed in golden hues. Monsoon adds waterfalls and mist to the scenery. The spot is popular among trekkers and photographers. Bombay Point is Bhimashankar’s scenic balcony to the Sahyadris."
  },
  {
    "title": "Origin of Bhima River",
    "description": "The Bhima River originates near the Bhimashankar Temple, adding to the region’s sacred significance. Pilgrims consider the river holy and perform rituals on its banks. The origin point is surrounded by greenery and serene landscapes. It is a tranquil place to reflect and connect with nature. Trekkers often explore it during monsoon. The Bhima River’s origin is Bhimashankar’s sacred natural wonder."
  },
  {
    "title": "Trekking Trails of Bhimashankar",
    "description": "Bhimashankar is a paradise for trekkers with multiple routes through dense forests, valleys, and waterfalls. Popular trails include the Shidi Ghat, Ganesh Ghat, and routes via Khandas village. Monsoon adds adventure with slippery paths and roaring streams. Trekkers enjoy camping and stargazing in the wild. Each trail offers a unique blend of thrill and spirituality. Bhimashankar trekking trails are Maharashtra’s favorite adventure escapes."
  },
  {
    "title": "Ahupe Ghat",
    "description": "Ahupe Ghat, located near Bhimashankar, is a stunning mountain pass offering views of the Konkan plains and surrounding valleys. The ghat is popular among trekkers and nature lovers. Mist, waterfalls, and lush greenery make it breathtaking in monsoon. The remote location ensures peace away from crowds. Photographers capture surreal landscapes here. Ahupe Ghat is Bhimashankar’s offbeat natural retreat."
  },
  {
    "title": "Manmodi Caves",
    "description": "Manmodi Caves, near Bhimashankar, are ancient Buddhist rock-cut caves dating back to the Satavahana period. The caves have viharas, chaityas, and inscriptions that reflect Buddhist culture. Though less visited, they are historically significant and ideal for explorers. Surrounded by hills, they add a heritage touch to the trip. Monsoon makes the site greener and more scenic. Manmodi Caves are Bhimashankar’s hidden historical gem."
  }
],



 "services": [
    {
      "name": "Pune to Bhimashankar Cab",
      "description": "Reliable and comfortable cab service from Pune to Bhimashankar, perfect for pilgrims visiting the famous Bhimashankar temple. Enjoy hassle-free travel with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune to Bhimashankar Taxi Fare",
      "description": "Affordable and transparent taxi fare options for trips from Pune to Bhimashankar, offering competitive pricing without compromising on comfort or safety."
    },
    {
      "name": "Pune to Bhimashankar Cab fare",
      "description": "Clear and upfront cab fare structure for Pune to Bhimashankar journeys, helping travelers plan their budget effectively for a spiritual trip."
    },
    {
      "name": "Taxi from Pune to Bhimashankar",
      "description": "Professional taxi service from Pune to Bhimashankar with experienced drivers, ensuring timely pickups and comfortable rides through scenic routes."
    },
    {
      "name": "Pune to Bhimashankar cab price",
      "description": "Competitive cab pricing from Pune to Bhimashankar with options ranging from economy to premium vehicles tailored to your travel needs."
    },
    {
      "name": "Book cab from Pune to Bhimashankar",
      "description": "Easy online booking platform for Pune to Bhimashankar cabs with instant confirmation, secure payments, and customer support available 24/7."
    },
    {
      "name": "Pune to Bhimashankar by cab charges",
      "description": "Transparent cab charges for travel from Pune to Bhimashankar, including tolls, driver allowances, and other fees for a hassle-free experience."
    },
    {
      "name": "Pune to Bhimashankar cab booking",
      "description": "Quick and convenient cab booking services for Pune to Bhimashankar with a variety of vehicle options to suit solo travelers and groups alike."
    },
    {
      "name": "Pune to Bhimashankar cab charges",
      "description": "Detailed cab charges for Pune to Bhimashankar trips ensuring no hidden costs, with affordable packages customized for your travel preferences."
    },
    {
      "name": "Pune to Bhimashankar Cab Package",
      "description": "All-inclusive cab packages for Pune to Bhimashankar covering transport, tolls, driver allowances, and optional sightseeing, ideal for group tours and religious visits."
    },
    {
      "name": "Pune to Bhimashankar car rental",
      "description": "Flexible car rental options from Pune to Bhimashankar, including self-drive and chauffeur-driven cars, allowing you to explore at your own pace."
    },
    {
      "name": "Pune to Bhimashankar taxi service",
      "description": "Dedicated taxi services from Pune to Bhimashankar focusing on comfort, punctuality, and safety for a serene journey to the temple town."
    },
    {
      "name": "Pune to Bhimashankar taxi price",
      "description": "Competitive and affordable taxi pricing from Pune to Bhimashankar with multiple vehicle choices to match your budget and preferences."
    },
    {
      "name": "Pune to Bhimashankar temple cab fare",
      "description": "Specialized cab fares for trips to Bhimashankar temple from Pune, designed to meet the needs of pilgrims with comfortable vehicles and courteous drivers."
    },
    {
      "name": "Pune to Bhimashankar tempo traveller",
      "description": "Spacious and comfortable tempo traveller rentals from Pune to Bhimashankar, ideal for large groups and family trips ensuring ample room and convenience."
    },
    {
      "name": "Taxi service from Pune to Bhimashankar",
      "description": "Reliable and professional taxi services from Pune to Bhimashankar with a focus on customer satisfaction, timely service, and safe travel."
    },
    {
      "name": "Pune to Bhimashankar Innova Crysta",
      "description": "Premium Innova Crysta cab rentals from Pune to Bhimashankar, offering luxury, comfort, and ample space for a smooth and enjoyable journey."
    },
    {
      "name": "Pune to Bhimashankar tempo traveller",
      "description": "Tempo traveller services from Pune to Bhimashankar catering to large groups, providing a comfortable and spacious travel experience to the temple destination."
    }
  ],
  "tableData": [
    ["Pune to Bhimashankar Cab", "Pune to Bhimashankar Taxi Fare"],
    ["Pune to Bhimashankar Cab fare", "Taxi from Pune to Bhimashankar"],
    ["Pune to Bhimashankar cab price", "Book cab from Pune to Bhimashankar"],
    ["Pune to Bhimashankar by cab charges", "Pune to Bhimashankar cab booking"],
    ["Pune to Bhimashankar cab charges", "Pune to Bhimashankar Cab Package"],
    ["Pune to Bhimashankar car rental", "Pune to Bhimashankar taxi service"],
    ["Pune to Bhimashankar taxi price", "Pune to Bhimashankar temple cab fare"],
    ["Pune to Bhimashankar tempo traveller", "Taxi service from Pune to Bhimashankar"],
    ["Pune to Bhimashankar Innova Crysta", "Pune to Bhimashankar tempo traveller"]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Bhimashankar Cab Services",
        "WhyChoosedescription": "Platinum24 Cabs provides budget-friendly and comfortable cab rides from Pune to Bhimashankar for a hassle-free pilgrimage or trip."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Vehicles for Scenic Journeys",
        "WhyChoosedescription": "Travel comfortably in our well-maintained cabs, perfect for the scenic route to Bhimashankar."
    },
    {
        "WhyChooseheading": "Clean and Sanitized Fleet for Your Safety",
        "WhyChoosedescription": "We ensure all vehicles are regularly cleaned and sanitized before every trip to maintain high hygiene standards."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Expertise",
        "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Bhimashankar route, ensuring a safe and timely journey."
    },
    {
        "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
        "WhyChoosedescription": "Choose from one-way, round-trip, or customized packages tailored to your travel needs."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy upfront, all-inclusive pricing covering fuel, tolls, and driver allowances for complete peace of mind."
    },
    {
        "WhyChooseheading": "Ideal for Pilgrimage Trips, Family Outings, and Group Travel",
        "WhyChoosedescription": "Our Pune to Bhimashankar cab services cater to religious visits, family trips, and group tours alike."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
        "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, changes, and special requests."
    }
]















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services from Pune to Bhimashankar?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services for travel between Pune and Bhimashankar.',
    },
    {
        question: 'How can I book a Pune to Bhimashankar cab with Platinum24 Cabs?',
        answer: 'You can easily book your Pune to Bhimashankar cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for Pune to Bhimashankar trips?',
        answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars to suit your travel preferences and budget.',
    },
    {
        question: 'Are the drivers experienced for long-distance travel like Pune to Bhimashankar?',
        answer: 'Yes, all our drivers are professional, experienced, and knowledgeable about the Pune to Bhimashankar route.',
    },
    {
        question: 'Can I book a round trip cab from Pune to Bhimashankar?',
        answer: 'Absolutely! We offer round-trip cab services with flexible scheduling to accommodate your travel plans.',
    },
    {
        question: 'What is included in the fare for Pune to Bhimashankar cab services?',
        answer: 'The fare includes vehicle charges, driver allowance, fuel, tolls, and taxes. Additional charges may apply for extra stops or waiting time.',
    },
    {
        question: 'Can I customize pickup and drop-off locations for Pune to Bhimashankar rides?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points along the Pune-Bhimashankar route.',
    },
    {
        question: 'Are safety measures in place for Pune to Bhimashankar cab rides?',
        answer: 'All vehicles are regularly sanitized, and our drivers follow strict safety protocols to ensure a safe and comfortable journey.',
    },
    {
        question: 'Is it possible to hire a cab for multiple days for Pune to Bhimashankar travel?',
        answer: 'Yes, we offer hourly and multi-day rental packages tailored to your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate taxi services from Pune to Bhimashankar?',
        answer: 'Yes, we offer customized corporate travel solutions including priority support and flexible billing for Pune to Bhimashankar routes.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sandeep Kulkarni',
        feedback: 'I had a great experience booking a cab from Pune to Bhimashankar with Platinum24 Cabs. The service was punctual and the driver was courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Patil',
        feedback: 'Platinum24 Cabs made our Pune to Bhimashankar trip very smooth and comfortable. Highly recommended!',
        rating: 5,
    },
];






























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const puneToBhimashankarCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Cab",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-bhimashankar-cab.jpg",
  "description": "Book Pune to Bhimashankar cab service with Platinum24 Cabs. Affordable taxi fares, car rentals including Innova Crysta and tempo travellers, perfect for temple visits and sightseeing.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "11200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1450",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-bhimashankar-cab"
  }
};





    return (
        <div>
<Helmet>
  <title>Pune to Bhimashankar Cab | Temple Taxi & Car Rentals | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Bhimashankar cab service with Platinum24 Cabs. Affordable taxi fares, car rentals including Innova Crysta and tempo travellers, perfect for temple visits and sightseeing."
  />
  <meta
    name="keywords"
    content="Pune to Bhimashankar Cab, Pune to Bhimashankar Taxi Fare, Pune to Bhimashankar Cab fare, Taxi from Pune to Bhimashankar, Pune to Bhimashankar cab price, Book cab from Pune to Bhimashankar, Pune to Bhimashankar by cab charges, Pune to Bhimashankar cab booking, Pune to Bhimashankar cab charges, Pune to Bhimashankar Cab Package, Pune to Bhimashankar car rental, Pune to Bhimashankar taxi service, Pune to Bhimashankar taxi price, Pune to Bhimashankar temple cab fare, Pune to Bhimashankar tempo traveller, Taxi service from Pune to Bhimashankar, Pune to Bhimashankar Innova Crysta, Pune to Bhimashankar tempo traveller"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToBhimashankarCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetobhimashankarcabs;